'use client';

import React from 'react';
import type { ReactNode } from 'react';
import { MobileMenu } from '@/widgets/mobile-menu';
import { GlobalModals } from './global-modals';
import { MainContentFrame } from './layout-frame';
import { HeaderSlot } from './styles';
import { WalletContext } from '@/shared/providers/wallet-context';

interface ModalControls {
  onClose: () => void;
  onOpen: () => void;
  visible: boolean;
}

interface WalletModalControls extends ModalControls {
  initialStep?: 'deposit' | 'withdraw' | 'history-detail';
}

interface CommonLayoutContentProps {
  authManagement: ModalControls;
  cashbackModal: ModalControls;
  children: ReactNode;
  flexMain?: boolean;
  footer: ReactNode;
  header: ReactNode;
  headerEnabled: boolean;
  hideFooter?: boolean;
  mode: 'auth' | 'base';
  walletManagement?: WalletModalControls;
}

export const LayoutContent = (props: CommonLayoutContentProps) => {
  const {
    authManagement,
    cashbackModal,
    children,
    flexMain,
    footer,
    header,
    headerEnabled,
    hideFooter = false,
    mode,
  } = props;

  const isAuth = mode === 'auth';
  const walletManagement = isAuth ? props.walletManagement : undefined;
  const openWalletManagement =
    walletManagement?.onOpen ?? authManagement.onOpen;

  return (
    <>
      <WalletContext.Provider value={{ openWallet: openWalletManagement }}>
        <HeaderSlot $hideInLandscape={!headerEnabled}>{header}</HeaderSlot>
        <MainContentFrame
          flexMain={flexMain}
          hideFooter={hideFooter}
          footer={footer}
          mobileMenu={
            <MobileMenu
              openWalletManagement={
                isAuth ? openWalletManagement : authManagement.onOpen
              }
              $flexMain={flexMain}
            />
          }
        >
          {children}
        </MainContentFrame>
      </WalletContext.Provider>
      <GlobalModals
        mode={mode}
        authManagement={authManagement}
        walletManagement={walletManagement}
        cashbackModal={cashbackModal}
      />
    </>
  );
};
